import SkeletonElement from "@/components/Skeleton/SkeletonElement";

export default function TaskSideSheetSkeleton() {
  return (
    <div className="pt-7">
      <div className="flex flex-col gap-6">
        <div data-testid="task-skeleton" className="space-y-4">
          <div className="flex items-center space-x-4">
            <SkeletonElement height="h-12" width="w-12" rounded="rounded-full" />
            <div className="flex-1 space-y-2 py-1">
              <SkeletonElement height="h-4" width="w-3/4" />
              <SkeletonElement height="h-4" width="w-1/2" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-2 items-start mt-8">
        <SkeletonElement height="h-6" width="w-20" />
        <div className="space-y-4 w-full">
          <div className="flex items-center gap-4">
            <SkeletonElement height="h-10" width="w-10" rounded="rounded-full" />
            <div className="flex-1 space-y-1">
              <SkeletonElement height="h-3" width="w-16" />
              <SkeletonElement height="h-4" width="w-48" />
            </div>
          </div>
          <div className="flex items-center gap-4">
            <SkeletonElement height="h-10" width="w-10" rounded="rounded-md" />
            <div className="flex-1 space-y-1">
              <SkeletonElement height="h-3" width="w-16" />
              <SkeletonElement height="h-4" width="w-32" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-2 items-start mt-8">
        <SkeletonElement height="h-6" width="w-16" />
        <div className="space-y-4 w-full">
          <div className="flex items-center gap-4">
            <SkeletonElement height="h-10" width="w-10" rounded="rounded-md" />
            <div className="flex-1 space-y-1">
              <SkeletonElement height="h-3" width="w-20" />
              <SkeletonElement height="h-4" width="w-full" />
              <SkeletonElement height="h-4" width="w-3/4" />
            </div>
          </div>
          <div className="flex items-center gap-4">
            <SkeletonElement height="h-10" width="w-10" rounded="rounded-md" />
            <div className="flex-1 space-y-1">
              <SkeletonElement height="h-3" width="w-20" />
              <SkeletonElement height="h-4" width="w-40" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
